import { AUTH_SECRET_ID } from '../../config/constants.ts';

export function getAuthToken(): string | null {
  return localStorage.getItem('access_token') ?? sessionStorage.getItem('access_token');
}

export function getRefreshToken(): string | null {
  return localStorage.getItem('refresh_token');
}

export function clearAuthData() {
  localStorage.removeItem('access_token');
  localStorage.removeItem('refresh_token');
  sessionStorage.removeItem('access_token');
  sessionStorage.removeItem('refresh_token');
  sessionStorage.removeItem('refreshed');
  sessionStorage.removeItem('unlicensed');
}

export function buildAuthHeader(url: string, token: string): string {
  return url.includes('refresh_token') ? `Basic ${AUTH_SECRET_ID}` : `Bearer ${token}`;
}
